import { render, staticRenderFns } from "./ClientUpdateModal.vue?vue&type=template&id=331886d9&scoped=true&"
import script from "./ClientUpdateModal.vue?vue&type=script&lang=js&"
export * from "./ClientUpdateModal.vue?vue&type=script&lang=js&"
import style0 from "./ClientUpdateModal.vue?vue&type=style&index=0&id=331886d9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "331886d9",
  null
  
)

export default component.exports